var React = require('react');

function School (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.17 10.28-5.39-3m5.4 3V15m0-4.72 5.04-2.94M17 5.72 9.17 1 1 5.72l2.78 1.55M17 5.73l-2.78 1.61M17 5.72v6.13M3.78 7.27v4.58L9.18 15m0 0 5.04-3.15v-4.5","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

School.defaultProps = {"fill":"none","viewBox":"0 0 18 16"};

module.exports = School;

School.default = School;
